import * as React from 'react';
import { Props } from './../types/types';
import logo from './../svgs/logo-wijkwijzer-fc.svg';
import { View, Text } from './../libs/WebComponents';

const AppHeader = (props: Props)=>{

   return (
      <header className={`view App-header ${props.index===0?'introduction':'default'}`}>
            <View className="view header-logo">
               <img src={logo} alt="logo" />
            </View>
            <View className="header-content">
               <Text>{props.title}</Text>
            </View>
         </header>
   );
}

export default React.memo(AppHeader);